import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Tip } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class TipService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  getTips() {
    return this.http.get<Tip[]>(`${this.BASE_URL}api/my-rova/tips`);
  }

  getInsightsTips() {
    return this.http.get<Tip[]>(`${this.BASE_URL}api/my-rova/tips/insights`);
  }
}
